import Emitter from '../utils/event-emitter-generic';
class EmitterMachine extends Emitter {
}
export default EmitterMachine;
